import { SUPPORTED_LANGUAGES, SupportedLanguage } from '@/constants/language';

export const isSupportedLanguage = (
  locale: string,
): locale is SupportedLanguage => {
  return SUPPORTED_LANGUAGES.includes(locale as SupportedLanguage);
};

export const getSupportedLanguage = (locale?: string): SupportedLanguage => {
  return locale && isSupportedLanguage(locale)
    ? (locale as SupportedLanguage)
    : 'en';
};

export const toggleLanguage = (
  locale: SupportedLanguage,
): SupportedLanguage => {
  return locale === 'en' ? 'ko' : 'en';
};
